module.exports = __webpack_public_path__ + "static/media/comp_icon.5d61b015.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/comp_icon.png
// module id = 201
// module chunks = 0